import PagedResponse from '../PagedResponse';
import { buildQueryParams, QueryParameters } from '../QueryParameters';
import {
  Delete, Get, Post, Put,
} from '../requestBuilder/buildFetchRequest';
import AddPayPeriod from './AddPayPeriod';
import PayPeriod from './PayPeriod';
import PayPeriodQueryOptions from './PayPeriodQueryOptions';
import UpdatePayPeriod from './UpdatePayPeriod';

// eslint-disable-next-line import/prefer-default-export
export const getPayPeriods = (query: QueryParameters<PayPeriod, PayPeriodQueryOptions>): Promise<PagedResponse<PayPeriod>> => (
  Get('/api/payperiods')
    .AddQueryParams(buildQueryParams(query))
    .Execute()
);

export const getPayPeriod = (id: number): Promise<PayPeriod> => (
  Get(`/api/payperiods/${id}`)
    .Execute()
);

export const getNextAvailablePayPeriod = (): Promise<PayPeriod> => (
  Get('/api/payperiods/nextavailable')
    .Execute()
);

export const addPayPeriod = (request: AddPayPeriod): Promise<void> => (
  Post('/api/payperiods')
    .AddBody(request)
    .Execute()
);

export const deletePayPeriod = (id: number): Promise<void> => (
  Delete(`/api/payperiods/${id}`)
    .Execute()
);

export const updatePayPeriod = (id: number, request: UpdatePayPeriod): Promise<void> => (
  Put(`/api/payperiods/${id}`)
    .AddBody(request)
    .Execute()
);

export const lockPayPeriod = (id: number): Promise<void> => (
  Post(`/api/payperiods/${id}/lock`)
    .Execute()
);

export const unlockPayPeriod = (id: number): Promise<void> => (
  Post(`/api/payperiods/${id}/unlock`)
    .Execute()
);
